import { useState } from 'react';
import { Button } from '@mui/material';
import useStyles from './OpenSettingsModalButton.styles';
import SettingsModal from './SettingsModal';
import DeleteOrQuitFolderConfirmationModal from './DeleteOrQuitFolderConfirmationModal';
import { SettingsContextProvider } from './SettingsContext';
import {ShareFolderSettings} from 'components/icons';

const OpenSettingsModalButton = (): JSX.Element => {
  const classes = useStyles();
  const [showDeleteOrQuitModal, setShowDeleteOrQuitModal] = useState<boolean>(false);
  const [showSettingsModal, setShowSettingsModal] = useState<boolean>(false);

  const handleOpen = () => setShowSettingsModal(true);

  return (
    <SettingsContextProvider
      showDeleteOrQuitModal={showDeleteOrQuitModal}
      showSettingsModal={showSettingsModal}
      setShowDeleteOrQuitModal={setShowDeleteOrQuitModal}
      setShowSettingsModal={setShowSettingsModal}
    >
      <Button
        className={classes.button}
        data-testid="open-settings-modal-button"
        onClick={handleOpen}
      >
        <ShareFolderSettings fontSize='xlarge' />
      </Button>

      <SettingsModal />

      <DeleteOrQuitFolderConfirmationModal />
    </SettingsContextProvider>
  );
};

export default OpenSettingsModalButton;
